module.exports = __webpack_public_path__ + "static/media/EventSurfing.e3d1090f.png";